import { Montserrat, Noto_Sans_JP, Noto_Sans_KR, Noto_Sans_SC, Noto_Sans_TC } from 'next/font/google'

import type { Language } from '../providers/i18n/types'

const montserrat = Montserrat({
    subsets: ['latin', 'cyrillic'],
    variable: '--font-montserrat-face',
})

// Google serves the CJK families as unnamed unicode-range slices, so there is no subset to
// preload — the browser fetches only the slices a page's glyphs need. `weight` is omitted to
// get the variable font. `--font-noto-cjk` is appended after the latin face, not a replacement:
// news copy stays en/ru, so latin/cyrillic must keep Montserrat.
const notoSansJP = Noto_Sans_JP({ preload: false, variable: '--font-noto-cjk' })
const notoSansKR = Noto_Sans_KR({ preload: false, variable: '--font-noto-cjk' })
const notoSansSC = Noto_Sans_SC({ preload: false, variable: '--font-noto-cjk' })
const notoSansTC = Noto_Sans_TC({ preload: false, variable: '--font-noto-cjk' })

const cjkFontByLanguage: Partial<Record<Language, { variable: string }>> = {
    ja: notoSansJP,
    ko: notoSansKR,
    cn: notoSansSC,
    tw: notoSansTC,
}

export function fontFaceVariables(lang: Language): string {
    return [montserrat.variable, cjkFontByLanguage[lang]?.variable].filter(Boolean).join(' ')
}

/** Panda `montserrat` token reads this. CJK is a fallback, not a substitute. */
export function fontTokenCss(lang: Language): string {
    const cjk = cjkFontByLanguage[lang]
    const montserratStack = cjk ? 'var(--font-montserrat-face), var(--font-noto-cjk)' : 'var(--font-montserrat-face)'

    return `:root { --font-montserrat: ${montserratStack}; } body { font-family: var(--font-montserrat); }`
}
